function HomePage() {
  const {
    HeroSection,
    StatsSection,
    ProductsSection,
    FeaturesSection,
    PlansSection,
    ReviewsSection,
    MobileSection,
    FaqSection,
  } = window.AppSections;
  const { Footer } = window.AppLayout;

  return (
    <div className="min-h-screen w-full px-3 py-5 text-ink md:px-5 lg:px-6">
      <HeroSection />

      <main>
        <StatsSection />
        <ProductsSection />
        <FeaturesSection />
        <PlansSection />
        <ReviewsSection />
        <MobileSection />
        <FaqSection />
      </main>

      <Footer />
    </div>
  );
}

window.AppPages = window.AppPages || {};
window.AppPages.HomePage = HomePage;
